import * as React from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

export function BacteriumSelect({
    options = [],
    value,
    onChange,
    placeholder = "Choose a bacterium",
    sx
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleSelect = (val) => {
        onChange?.(val);
        handleClose();
    };
    const hasValue = Boolean(value);
    const label = hasValue ? value : placeholder;

    return (
        <Box sx={{ width: "100%", ...sx }}>
            <Button
                fullWidth
                disableRipple
                onClick={handleOpen}
                endIcon={<KeyboardArrowDownRoundedIcon />}
                sx={{
                    justifyContent: "space-between",
                    textTransform: "none",
                    color: hasValue ? "text.primary" : "text.secondary",
                    fontWeight: hasValue ? 500 : 400,
                    px: 2,
                    py: 1.25,
                    minHeight: 44,
                    borderTop: "1px solid #222",
                    borderBottom: "1px solid #222",
                    borderRadius: 0,
                    "&:hover": { bgcolor: "transparent" },
                    "&:focus-visible": { outline: "none" },
                }}
            >
                <Typography variant="body1">
                    {label}
                </Typography>
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                MenuListProps={{ dense: true, sx: { py: 1 } }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        mt: 0,               // pegado al “input”
                        borderTop: "1px solid #222",
                        borderBottom: "1px solid #222",
                        borderRadius: 0,
                        boxShadow: "none",
                        minWidth: anchorEl?.offsetWidth, // mismo ancho que el botón
                    },
                }}
            >
                {options.map((opt) => (
                    <MenuItem
                        key={opt}
                        onClick={() => handleSelect(opt)}
                        selected={opt === value}
                        sx={{
                            px: 2,
                            py: 1,
                            fontWeight: opt === value ? 700 : 400, // negritas en seleccionado
                        }}
                    >
                        <Typography variant="body1">
                            {opt}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
}
